export default function LoadingSpinner() {
  return (
    <div className='scale-50'>
      <div className='loader animate-mul-shd-spin text-primary relative h-4 w-4 overflow-hidden rounded-full' />
    </div>
  );
}
